import { render, staticRenderFns } from "./FormLabelV2.vue?vue&type=template&id=d4143aa4&scoped=true&"
import script from "./FormLabelV2.vue?vue&type=script&lang=js&"
export * from "./FormLabelV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4143aa4",
  null
  
)

export default component.exports